import { render, staticRenderFns } from "./FailureReason.vue?vue&type=template&id=7b07e4b6&scoped=true"
import script from "./FailureReason.vue?vue&type=script&lang=js"
export * from "./FailureReason.vue?vue&type=script&lang=js"
import style0 from "./FailureReason.vue?vue&type=style&index=0&id=7b07e4b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07e4b6",
  null
  
)

export default component.exports